import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { of, Subscription } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UploadFile } from 'src/app/models';
import { DatetimeService, FilesService, NotificationService, ValidatorsService } from 'src/app/services';
import { AttachingCertificateValidator } from '../../certificates/attaching-certificate/attaching-certificate.validator';
import { UploadFileWithDateValidator } from './upload-file-with-date.validator';

@Component({
  selector: 'app-upload-file-with-date',
  templateUrl: './upload-file-with-date.component.html',
  styleUrls: ['./upload-file-with-date.component.css']
})
export class UploadFileWithDateComponent implements OnInit {

  @Input() set data(value) {

    if (value != null) {

      this.currentOrg = value.organizationId;
      this.btnUploadFilesMultiple = value.option.multiple;
      this.component = value.option.component;
    }
  }

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  btnUploadFilesMultiple: boolean = true;
  component: string;
  language: string;
  errorMessages: any;
  file: any;
  fileUploadObject: UploadFile = {
    data: null,
    inProgress: false,
    progress: 0,
    error: false,
    uploaded: false
  }
  currentOrg: string;
  result: any;
  currentDate = new Date();
  valueDate = this.datetimeService.convertDateForDatepicker(this.currentDate.setDate(this.currentDate.getDate() + 2));

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private validator: UploadFileWithDateValidator,
    private notification: NotificationService,
    private fileService: FilesService,
    public datetimeService: DatetimeService,
    private validatorService: ValidatorsService,
    public activeModal: NgbActiveModal,
  ) { }


  dateForm: UntypedFormGroup = this.fb.group({
    sell_by: [null, this.validator.sell_by]
  })

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnDPVC(fieldName: string, value: any): void {

    this.dateForm.controls[fieldName].setValue(value);

  }



  /**
   * 
   * @param files 
   * @returns 
   */
  onSelectedFiles(files: any = []): void {

    if (files.length == 0) return;

    this.file = files[0];

    this.fileUploadObject.data = files[0];
  }


  /**
   * 
   */
  // uploadFile(): void {

  //   const formData = new FormData();
  //   let methodName: string = 'uploadFile';

  //   formData.append('file', this.fileUploadObject.data);
  //   formData.append('org_id', this.currentOrg);
  //   formData.append('valid_to', this.dateForm.get('sell_by').value);

  //   console.log('DATA', this.dateForm.get('sell_by').value);

  //   console.log(formData.get('file'), formData.get('org_id'), formData.get('valid_to'));


  //   this.fileUploadObject.inProgress = true;

  //   console.log("FILE DATA: ", this.fileUploadObject.data)

  //   this.fileService.upload(methodName, formData).pipe(
  //     map(event => {
  //       switch (event.type) {
  //         case HttpEventType.UploadProgress:
  //           this.fileUploadObject.progress = Math.round(event.loaded * 100 / event.total);

  //           break;
  //         case HttpEventType.Response:
  //           return event;
  //       }
  //     }),
  //     catchError((error: HttpErrorResponse) => {

  //       this.fileUploadObject.inProgress = false;
  //       this.fileUploadObject.error = true;

  //       this.notification.show('danger', 'Загрузка файла ' + this.fileUploadObject.data.name + ' не удалась.');

  //       return of('Загрузка файла ' + this.fileUploadObject.data.name + ' не удалась.');

  //     })).subscribe((event: any) => {

  //       if (typeof (event) === 'object') {

  //         setTimeout(() => {

  //           console.log('[UPLOAD FILE]: ', event);

  //           if (event.body == null) return;

  //           this.fileUploadObject.inProgress = false;
  //           this.fileUploadObject.uploaded = true;

  //           this.result = event.body;

  //           this.notification.show('success', 'Загрузка файла выполнена успешно!');

  //           this.fileUploadObject.data = null;

  //           this.activeModal.close(true);

  //         }, 2000)
  //       }
  //     }
  //     );
  // }


  /**
   * 
   * @param field 
   * @param type 
   * @returns 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.dateForm.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.dateForm);
  }

  /**
   * 
   */
  uploadFiles(result) {

    this.activeModal.close(result);
  }

}
